export default __webpack_public_path__ + "static/media/img4.3596d99d.PNG";